import { IUser } from "@/api";
import { Grid, Stack, Typography } from "@mui/material";
import { UserRegistrationStatus } from "./UserRegistrationStatus";
import { DeleteUserButton } from "./buttons/DeleteUserButton";
import { EditUserButton } from "./buttons/EditUserButton";

interface IProps {
    user: IUser;
}

export const UserInformation = ({ user }: IProps) => {
    return (
        <Stack gap={2}>
            <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                <Typography variant="h6">Information</Typography>

                <Stack direction={"row"} spacing={0.5}>
                    <EditUserButton user={user} />
                    <DeleteUserButton userId={user.id} />
                </Stack>
            </Stack>

            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Stack gap={2}>
                        {/* ID */}
                        <Stack>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                fontWeight={500}
                                gutterBottom
                            >
                                ID
                            </Typography>
                            <Typography variant="body2">#{user.id}</Typography>
                        </Stack>

                        {/* First Name */}
                        <Stack>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                fontWeight={500}
                                gutterBottom
                            >
                                First Name
                            </Typography>
                            <Typography variant="body2">
                                {user.first_name}
                            </Typography>
                        </Stack>

                        {/* Last Name */}

                        <Stack>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                fontWeight={500}
                                gutterBottom
                            >
                                Last Name
                            </Typography>
                            <Typography variant="body2">
                                {user.last_name}
                            </Typography>
                        </Stack>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Stack gap={2}>
                        {/* Email */}
                        <Stack>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                fontWeight={500}
                                gutterBottom
                            >
                                Email
                            </Typography>
                            <Typography variant="body2">
                                {user.email}
                            </Typography>
                        </Stack>

                        {/* Invitation Status (or Registration Date if no invitation) */}
                        <Stack>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                fontWeight={500}
                                gutterBottom
                            >
                                {user.invitation_id
                                    ? "Invitation Status"
                                    : "Registration Date"}
                            </Typography>
                            <UserRegistrationStatus
                                invitationId={user.invitation_id ?? null}
                                createdAt={user.created_at}
                            />
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </Stack>
    );
};
